import { CSSProperties } from '@mui/styles';

/**
 * Mixin to easily re-use the webkit-line-clamp approach to give a multiline
 * text overflow with ellipsis, up to the maximum number of given lines.
 *
 * Usage:
 *  1. Create some styles with MUI's useStyles
 *
 *      import makeStyles from '@mui/styles/makeStyles';
 *      import Theme from '@mui/styles/Theme';
 *
 *      const useStyles = makeStyles((theme: Theme) => ({
 *        multilineText: {
 *          color: palevioletred,
 *        }
 *      }));
 *
 *  2. To the class name that will hold the multiline ellipsis styles,
 *     use the spread operator for this mixin's execution result:
 *
 *      import makeStyles from '@mui/styles/makeStyles';
 *      import Theme from '@mui/styles/Theme';
 *
 *      const useStyles = makeStyles((theme: Theme) => ({
 *        multilineText: {
 *          color: palevioletred,
 *          ...multlineEllipsis(3),
 *        }
 *      }));
 *
 *  3. Use this class in the element/component you wish to give the styles
 *
 *      <Typography className={classes.multilineText}>Hello, World!</Typography>
 *
 */
export const multilineEllipsis = (lines = 2): CSSProperties => ({
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  '-webkit-line-clamp': `${lines}`,
  '-webkit-box-orient': 'vertical',
});

export const ellipsis = (): CSSProperties => ({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const hoverFix = {
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
  '&.Mui-selected.Mui-focusVisible': {
    backgroundColor: 'rgba(0, 0, 0, 0.08)',
  },
};
